module.exports = __webpack_public_path__ + "img/Colonies Button.ed8a00e3.svg";